import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faArrowLeft, faUserLock } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-account-inactive',
  templateUrl: './account-inactive.component.html',
  styleUrls: ['./account-inactive.component.scss'],
  standalone: true,
  imports: [
    FontAwesomeModule,
    RouterLink,
  ],
})
export class AccountInactiveComponent {
  protected readonly faArrowLeft = faArrowLeft;
  protected readonly faUserLock = faUserLock;
}
